<template>
  <main class="designers" v-if="payload">
    <div class="list"
      v-for="(list, key) in lists"
      :class="{'list--active': activeList.includes(key)}"
      :key="`list${key}`">
      <div class="list__head">
        <button v-html="`${list.year } Designers`" @click="toggleList(key)"></button>
      </div>
      <ul class="list__body">
        <li v-for="(designer, key) in list.designers" :key="`designer${key}`" class="list__item">
          <router-link :to="getDesignerLink(designer.slug)" v-html="formatName(designer.first_name, designer.last_name)"></router-link>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'

export default {
  name: 'Designers',
  extends: ApiPage,
  data() {
    return {
      payload: null,
      lists: null,
      activeList: [0]
    }
  },
  methods: {
    formatName(first, last) {
      return `${first} ${last}`
    },
    getDesignerLink(slug) {
      return `/designers/${slug}`
    },
    toggleList(key) {
      if (this.activeList.includes(key)) {
        this.activeList.splice(this.activeList.indexOf(key))
      } else {
        this.activeList.push(key)
      }
    },
    filterDesigners(designers) {
      // filter, sort
      let designersArr = Array.from(designers)
      
      if (Array.isArray(designersArr) && designersArr.length === 0) {
        designersArr = Object.keys(designers).map(designer => {
          return designers[designer]
        })
      }

      // filter designers array for first name and last name
      let filteredDesigners = designersArr.filter(designer => {
        if (designer.first_name && designer.last_name) return true
      })

      // sort filtered designers by first name
      filteredDesigners.sort((a, b) => {
        return (a.first_name > b.first_name ? 1 : (b.first_name > a.first_name ? -1 : 0))
      })

      return filteredDesigners
    }
  },
  watch: {
    'payload.lists': function(newVal) {
      this.lists = newVal.filter(list => {
        if (typeof list.year !== typeof null) return true 
      }).map(list => {
        list.active = false

        // filter list
        list.designers = this.filterDesigners(list.designers)

        return list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.designers {
  @include page;
  display:flex;
  flex-direction: column;
  align-items: flex-end;

  .list {
    width:50%;
    text-align: right;
    &--active {
      .list__head {
        button {
          &:after {
            content:'(-)';
          }
        }
      }
      .list__body {
        display:block;
        margin:0 0 3rem 0;
      }
    }
    &__head {
      font-size:$heading;
      button {
        @include button_reset;
        position:relative;
        padding:0 4rem 0 0;
        cursor: pointer;
        &:after {
          content: '(+)';
          text-align: center;
          width:4rem;
          display:block;
          position:absolute;
          right:0px;
          top:50%;
          transform: translateY(-50%);
        }
      }
    }
    &__body {
      display:none;
    }
    &__item {
      font-size:$heading;
    }
  }
  @media screen and (max-width: $mobile) {
    .list {
      width:100%;

      &--active {
        .list__body {
          display:block;
          margin:0 0 1rem 0;
        }
      }

      &__head {
        font-size:$body--m;
        button {
          padding: 0 2rem 0 0;
          &:after {
            width:1.75rem;
          }
        }
      }

      &__item {
        font-size:$body--m;
      }
    }
  }
}
</style>
